import {
  postventaAnalisisResponse,
  postventaClosureSummaryResponse,
  postventaSurveySummaryResponse,
  type PostventaSurveySummaryResponse,
  postventaObservationsResponse,
  postventaTaxonomyMetricsResponse,
  type PostventaAnalisisResponse,
  type PostventaClosureSummaryResponse,
  type PostventaObservationsResponse,
  type PostventaTaxonomyMetricsResponse,
} from "@bitacorapro/api-types";
import { request } from "../client";

// Ingress parse (ADR-0021/D6), same posture as getFacilityDashboard.
// `assetGroupId` acota el feed a un proyecto en el SERVIDOR: la vista de
// un proyecto no se resuelve filtrando el feed de toda la inmobiliaria.
export async function getPostventaObservations(
  assetGroupId?: string
): Promise<PostventaObservationsResponse> {
  const qs = assetGroupId ? `?assetGroupId=${encodeURIComponent(assetGroupId)}` : "";
  const json = await request<unknown>("GET", "core", `/postventa-dashboard/observations${qs}`);
  return postventaObservationsResponse.parse(json);
}

// #0698/#0604 — cola OTR + pendientes del gate de confianza + acumulado
// matrix_gap. Counts-only.
export async function getPostventaTaxonomyMetrics(): Promise<PostventaTaxonomyMetricsResponse> {
  const json = await request<unknown>("GET", "core", "/postventa-dashboard/taxonomy-metrics");
  return postventaTaxonomyMetricsResponse.parse(json);
}

// ADR-0142 — el cierre por falta de respuesta del proyecto: el conteo
// aparte de las cerradas sin respuesta y la lista de observaciones
// bloqueadas porque al propietario no le llegan los correos. Mismo
// alcance que el feed. `enabled: false` = nada que mostrar.
export async function getPostventaClosureSummary(
  assetGroupId?: string
): Promise<PostventaClosureSummaryResponse> {
  const qs = assetGroupId ? `?assetGroupId=${encodeURIComponent(assetGroupId)}` : "";
  const json = await request<unknown>("GET", "core", `/postventa-dashboard/closure-summary${qs}`);
  return postventaClosureSummaryResponse.parse(json);
}

// ADR-0153 — las encuestas del propietario del proyecto: NPS por ola, la
// encuesta de la visita (general y por contratista) y los comentarios.
// Mismo alcance que el feed; un proyecto fuera de alcance da 404.
export async function getPostventaSurveySummary(
  assetGroupId?: string
): Promise<PostventaSurveySummaryResponse> {
  const qs = assetGroupId ? `?assetGroupId=${encodeURIComponent(assetGroupId)}` : "";
  const json = await request<unknown>("GET", "core", `/postventa-dashboard/survey-summary${qs}`);
  return postventaSurveySummaryResponse.parse(json);
}

// ADR-0154 — el análisis de cartera con IA. GET trae el último informe
// guardado del alcance (o `analisis: null`); POST calcula el expediente,
// pide el memo y lo guarda. Sin `assetGroupId`, la cartera completa; con
// él, ese proyecto contra el resto. Los dos devuelven la cuota de la org.
export async function getPostventaAnalisis(
  assetGroupId?: string
): Promise<PostventaAnalisisResponse> {
  const qs = assetGroupId ? `?assetGroupId=${encodeURIComponent(assetGroupId)}` : "";
  const json = await request<unknown>("GET", "core", `/postventa-dashboard/analisis${qs}`);
  return postventaAnalisisResponse.parse(json);
}

export async function generarPostventaAnalisis(
  assetGroupId?: string
): Promise<PostventaAnalisisResponse> {
  const json = await request<unknown>("POST", "core", "/postventa-dashboard/analisis", {
    body: assetGroupId ? { assetGroupId } : {},
  });
  return postventaAnalisisResponse.parse(json);
}
